import {
  Components, Theme, checkboxClasses, listItemIconClasses, menuItemClasses, svgIconClasses,
} from '@mui/material';
import { selectClasses } from '../select/types';
import { menuClasses } from './types';
import { Primary, Secondary } from '../color';
import { Spacing6 } from '../spacing';

export const MuiMenu: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    root: {
      [`.${selectClasses.placeholder}`]: {
        display: 'none',
      },

      [`&.${menuClasses.multiple} .${menuItemClasses.root}.${menuItemClasses.selected}`]: {
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: Secondary.surface.hover,
        },
      },
    },
  },
};

export const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      '&:hover': {
        backgroundColor: Secondary.surface.hover,
      },
      [`.${listItemIconClasses.root}`]: {
        height: Spacing6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 20,
        [`.${svgIconClasses.root}`]: {
          color: Primary.default.main,
        },
      },
      [`.${checkboxClasses.root}`]: {
        // TODO: find a better way to change the distance without messing up the hover circle
        marginLeft: -4,
      },
    },
  },
};
